export const PAPER_SIZES = {
    A5: "14.8 × 21 cm",
    A4: "21 × 29.7 cm",
    A3: "29.7 × 42 cm",
    A2: "42 × 59.4 cm",
};

export const SizeGuide = ({ sizes, active }) => {
    const rows = sizes.filter((s) => PAPER_SIZES[s.label.toUpperCase()]);
    if (!rows.length) return null;
    return (
        <div className="mt-6 border border-black/[0.08] bg-[#F0EDE5]/60 p-4 sm:p-5" data-testid="size-guide">
            <div className="label-caps mb-3 text-[#1A1A1A]">Size guide · paper size</div>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                {rows.map((s) => {
                    const key = s.label.toUpperCase();
                    const isActive = active === s.label;
                    return (
                        <div key={s.label} className={`text-sm ${isActive ? "text-[#1A1A1A]" : "text-[#5A5A5A]"}`} data-testid={`size-guide-${key.toLowerCase()}`}>
                            <div className={`font-serif-display text-lg ${isActive ? "text-[#8C3A3A]" : ""}`}>{key}</div>
                            <div>{PAPER_SIZES[key]}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
